import { useEffect, useState } from 'react';

const TIME_BEFORE_LOADING_TEXT = 1500;

interface Properties {
  readonly isLoading: boolean;
}

const useLoadingText = ({ isLoading }: Properties): string => {
  const [showLoading, setShowLoading] = useState(false);
  const [loadingStartTime, setLoadingStartTime] = useState<number | null>(null);

  useEffect(() => {
    if (isLoading && loadingStartTime === null) {
      queueMicrotask(() => {
        setLoadingStartTime(Date.now());
      });
    }

    const timeout = setTimeout(() => {
      if (isLoading) {
        setShowLoading(true);
      } else {
        if (loadingStartTime === null || Date.now() - loadingStartTime >= TIME_BEFORE_LOADING_TEXT) {
          setShowLoading(false); // Hide if loading never showed or was visible long enough
        }

        setLoadingStartTime(null);
      }
    }, TIME_BEFORE_LOADING_TEXT);

    return () => clearTimeout(timeout);
  }, [isLoading, loadingStartTime]);

  return showLoading ? 'Loading' : '';
};

export default useLoadingText;
